import React from 'react';
import Index from './components/Index';
import { AuthProvider } from './contexts/AuthContext';
import { PaymentModeProvider } from './contexts/PaymentModeContext';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import { Toaster } from 'sonner';
import { setupApiInterceptor } from './utils/apiInterceptor';

function App() {
  // Configurar interceptor do Axios para tratar respostas problemáticas do backend
  React.useEffect(() => {
    setupApiInterceptor();
  }, []);

  return (
    <ErrorBoundary>
      <AuthProvider>
        <PaymentModeProvider>
          <Index />
          <Toaster
            position="top-right"
            expand={true}
            richColors={true}
            closeButton={true}
          />
        </PaymentModeProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
